import { todayLabel } from "@/lib/format";

export default function PageHeader({ title, subtitle, action, testId }) {
  return (
    <header
      className="flex flex-col gap-4 pb-6 sm:flex-row sm:items-end sm:justify-between"
      data-testid={testId}
    >
      <div>
        <span className="ca-eyebrow">{todayLabel()}</span>
        <h1 className="ca-h1 mt-2">{title}</h1>
        {subtitle && (
          <p className="mt-2 max-w-prose text-sm text-[var(--ca-muted)]">{subtitle}</p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </header>
  );
}
